export default __webpack_public_path__ + "static/media/impact.e6c557f3.svg";